import client from '/src/services/client.js';

export default {
    getPhones: (data) => client.get(`phones`, data),
    getPhone: (id, data) => client.get(`phones/user/${id}`, data),
    addPhone: (data) => client.post(`phone`, data),
    updatePhone: (id, data) => client.put(`phone/${id}`, data),
    deletePhone: (id) => client.delete(`phone/${id}`),
    importPhones: (formData) => client.post(`phones/import`, formData),
    checkPhoneAvailability : (data) => client.get(`phone/check-availability`, data),
}
